import angular from 'angular'
import { assign } from 'lodash-es'

angular
  .module('ggs.gallery-image')
  .factory('ImageStateMachine', ImageStateMachineProvider)

function ImageStateMachineProvider($log) {
  const WAIT_THUMB = '0 - WAIT_THUMB: thumb-show image-hide retry-hide'
  const WAIT_IMAGE = '1 - WAIT_IMAGE: thumb-dsbl image-show retry-hide'
  const ONLY_THUMB = '2 - ONLY_THUMB: thumb-show image-dsbl retry-hide'
  const ONLY_IMAGE = '3 - ONLY_IMAGE: thumb-dsbl image-show retry-hide'
  const ONLY_RETRY = '4 - ONLY_RETRY: thumb-dsbl embed-dsbl retry-show'

  const STATE_TO_FLAGS = {
    [WAIT_THUMB]: {
      initsThumb: true,
      showsThumb: true,
      initsImage: true,
      showsImage: false,
      showsRetry: false
    },
    [WAIT_IMAGE]: {
      initsThumb: false,
      showsThumb: false,
      initsImage: true,
      showsImage: true,
      showsRetry: false
    },
    [ONLY_THUMB]: {
      initsThumb: true,
      showsThumb: true,
      initsImage: false,
      showsImage: false,
      showsRetry: false
    },
    [ONLY_IMAGE]: {
      initsThumb: false,
      showsThumb: false,
      initsImage: true,
      showsImage: true,
      showsRetry: false
    },
    [ONLY_RETRY]: {
      initsThumb: false,
      showsThumb: false,
      initsImage: false,
      showsImage: false,
      showsRetry: true
    }
  }

  /*          +-------WAIT_THUMB--------+
              |            |            |
              |            |            |
              |            |            |
              ▼            |            ▼
     +--▶WAIT_IMAGE--------|------▶ONLY_IMAGE
     |        |            |
     |        |            ▼
     |        |       ONLY_THUMB
     |        |
     |        ▼
     +---ONLY_RETRY
  */

  const STATE_MACHINE = {
    [WAIT_THUMB]: {
      flags: STATE_TO_FLAGS[WAIT_THUMB],
      rules: [{
        state: ONLY_IMAGE,
        test: (it) => it.imageStatus === it.DONE
      }, {
        state: ONLY_THUMB,
        test: (it) => true
          && it.thumbStatus === it.DONE
          && it.imageStatus === it.FAIL
      }, {
        state: WAIT_IMAGE,
        test: (it) => it.thumbStatus === it.FAIL
      }]
    },
    [WAIT_IMAGE]: {
      flags: STATE_TO_FLAGS[WAIT_IMAGE],
      rules: [{
        state: ONLY_IMAGE,
        test: (it) => it.imageStatus === it.DONE
      }, {
        state: ONLY_RETRY,
        test: (it) => it.imageStatus === it.FAIL
      }]
    },
    [ONLY_THUMB]: {
      flags: STATE_TO_FLAGS[ONLY_THUMB],
      rules: []
    },
    [ONLY_IMAGE]: {
      flags: STATE_TO_FLAGS[ONLY_IMAGE],
      rules: []
    },
    [ONLY_RETRY]: {
      flags: STATE_TO_FLAGS[ONLY_RETRY],
      rules: [{
        state: WAIT_IMAGE,
        test: (it) => it.imageStatus === it.REDO
      }]
    }
  }

  return function createMachine(it) {
    it.state = WAIT_THUMB
    setup(it)
    return () => recalc(it)
  }

  function recalc(it) {
    let newState = null
    const props = STATE_MACHINE[it.state]
    const rules = props.rules
    for (let i = 0, l = rules.length; i !== l; i++) {
      const rule = rules[i]
      if (rule.test(it)) {
        newState = rule.state
        break
      }
    }

    if (newState) {
      it.state = newState
      return setup(it)
    }
  }

  function setup(it) {
    const sign = `GalleryImage::ImageStateMachine[id=${it.ggsPost.id}]`
    $log.debug(`${sign}: init`, it.state)
    const props = STATE_MACHINE[it.state]
    assign(it, props.flags)
    $log.debug(`${sign}: done`, it.state)
    return recalc(it)
  }
}
